import { Table, Tag, Button, Space, Tooltip } from 'antd';
import {
  EyeOutlined,
  DeleteOutlined,
  LinkOutlined,
} from '@ant-design/icons';
import { formatDate } from '../../utils/dateHelpers';
import {
  FORM_STATUS_LABELS,
  FORM_STATUS_COLORS,
  getMoodEmoji,
} from '../../utils/validation';

const ReportsTable = ({ reports, loading, onView, onCopyLink, onDelete }) => {
  const columns = [
    {
      title: 'Сотрудник',
      dataIndex: ['teamMemberId', 'fullName'],
      key: 'member',
      sorter: (a, b) =>
        (a.teamMemberId?.fullName || '').localeCompare(b.teamMemberId?.fullName || ''),
    },
    {
      title: 'Создан',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (date) => formatDate(date),
      sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
      defaultSortOrder: 'descend',
    },
    {
      title: 'Срок до',
      dataIndex: 'expiresAt',
      key: 'expiresAt',
      render: (date) => formatDate(date),
    },
    {
      title: 'Настроение',
      dataIndex: 'moodScore',
      key: 'moodScore',
      render: (score) =>
        score ? (
          <Tooltip title={`${score}/10`}>
            <span>
              {getMoodEmoji(score)} {score}
            </span>
          </Tooltip>
        ) : (
          '—'
        ),
    },
    {
      title: 'Статус',
      dataIndex: 'status',
      key: 'status',
      render: (status) => (
        <Tag color={FORM_STATUS_COLORS[status]}>{FORM_STATUS_LABELS[status]}</Tag>
      ),
    },
    {
      title: 'Действия',
      key: 'actions',
      render: (_, record) => (
        <Space>
          <Button type="link" icon={<EyeOutlined />} onClick={() => onView(record)}>
            Просмотр
          </Button>
          {record.fillUrl && record.status !== 'expired' && record.status !== 'discussed' && (
            <Button type="link" icon={<LinkOutlined />} onClick={() => onCopyLink(record.fillUrl)}>
              Ссылка
            </Button>
          )}
          {onDelete && (
            <Button type="link" danger icon={<DeleteOutlined />} onClick={() => onDelete(record)} />
          )}
        </Space>
      ),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={reports}
      rowKey="_id"
      loading={loading}
      pagination={{ pageSize: 10, showSizeChanger: true }}
    />
  );
};

export default ReportsTable;
